// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import api from "@src/api/config"
import { showModalSuccess } from "../../../../redux/modalTypeSuccess"

const urlBase = "api/schooling-levels"

export const getSchoolingLevels = createAsyncThunk(
  "schoolingLevels/get",
  async (params) => {
    const response = await api.get(`${urlBase}`, { params })
    return {
      params,
      data: response.data
    }
  }
)

export const createSchoolingLevel = createAsyncThunk(
  "schoolingLevels/store",
  async (data, { dispatch }) => {
    const response = await api.post(`${urlBase}`, { name: data.concepto })
    const url = `/catalogs/schooling_levels`
    dispatch(showModalSuccess({ message: response.data.message, url }))
    return {
      data: response.data
    }
  }
)

export const getSchoolingLevelById = createAsyncThunk(
  "schoolingLevels/show",
  async (id) => {
    const response = await api.get(`${urlBase}/${id}`)
    return {
      data: response.data
    }
  }
)

export const editSchoolingLevel = createAsyncThunk(
  "schoolingLevels/edit",
  async ({ id, data }, { dispatch }) => {
    const response = await api.put(`${urlBase}/${id}`, { name: data.concepto })
    const url = `/catalogs/schooling_levels`
    dispatch(showModalSuccess({ message: response.data.message, url }))
    return {
      data: response.data
    }
  }
)

export const getSchoolingLevelsSuggestions = createAsyncThunk(
  "schoolingLevels/getSuggestions",
  async () => {
    const response = await api.get(`${urlBase}/suggestions`)
    return { data: response.data }
  }
)

export const deleteSchoolingLevel = createAsyncThunk(
  "schoolingLevels/delete",
  async (id, { dispatch }) => {
    const response = await api.delete(`${urlBase}/${id}`)
    const url = `/catalogs/schooling_levels`
    dispatch(showModalSuccess({ message: response.data.message, url }))
    dispatch(getSchoolingLevels({ page: 1 }))
    return {
      data: response.data
    }
  }
)

export const schoolingLevelsSlice = createSlice({
  name: "schoolingLevels",
  initialState: {
    data: [],
    suggestions: [],
    defaultValues: {},
    currentPage: 1,
    params: {},
    meta: {},
    total: 0
  },
  reducers: {
    cleanDefaultValues: (state) => {
      state.defaultValues = {}
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getSchoolingLevels.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.currentPage = action.payload.data.meta.current_page
      state.params = action.payload.params
      state.meta = action.payload.data.meta
      state.total = action.payload.data.meta.total
    })
    builder.addCase(createSchoolingLevel.fulfilled, (state, action) => {
      state.data = action.payload.data.data
    })
    builder.addCase(getSchoolingLevelsSuggestions.fulfilled, (state, action) => {
      state.suggestions = action.payload.data
    })
    builder.addCase(getSchoolingLevelById.fulfilled, (state, action) => {
      const payload = action.payload.data.data
      state.defaultValues = {
        concepto: payload.name
      }
    })
  }
})

export const { cleanDefaultValues } = schoolingLevelsSlice.actions
export default schoolingLevelsSlice.reducer
